import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_footwear_all: FaireCategoryEntity = {
  token: "cat_footwear-all",
  type: "category",
  name: "All footwear",
  level: 2,
  parentToken: "cat_footwear",
  href: "/category/footwear",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
